import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { baseurl, imageUrl } from "../../../Baseurl";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";

const EditCategory = () => {
  const { id } = useParams(); // Get ID from URL
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [isCategory, setIsCategory] = useState(false); // State for checkbox

  // Fetch category data by ID
  useEffect(() => {
    axios
      .get(`${baseurl}getMenuById/${id}`)
      .then((response) => {
        setTitle(response.data.title);
        setPreview(`${imageUrl}menu/${response.data.image}`);
        setIsCategory(response.data.is_category || false); // Ensure it updates correctly
      })
      .catch((error) => console.error("Error fetching category data:", error));
  }, [id]);

  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("is_category", isCategory ? "true" : "false"); // Send as "true" or "false"
      if (image) formData.append("image", image);
  
      // Log FormData values
      console.log("📤 Sending Form Data:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
  
      await axios.put(`${baseurl}updateMenuWithImage/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      Swal.fire({
        title: "Success!",
        text: "Category updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload();
      });
  
    } catch (error) {
      console.error("❌ Error updating category:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to update category. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="crd1">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4 className="text-start">Edit Item Category</h4>
            </div>

            <form onSubmit={handleSubmit} className="row g-2 text-start">
              {/* Item Name */}
              <div className="col-md-8">
                <label className="form-label">Item Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter item name"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />
              </div>

              {/* Checkbox for Category */}
              <div className="col-md-8">
                <label className="form-label">Does this Category Have Products?</label>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="isCategory"
                    checked={isCategory}
                    onChange={(e) => setIsCategory(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="isCategory">
                    Yes, this category contains products.
                  </label>
                </div>
              </div>

              {/* Image Upload */}
              <div className="col-md-8">
                <label className="form-label">Upload Image</label>
                <input type="file" className="form-control" accept="image/*" onChange={handleImageChange} />
                {preview && <img src={preview} alt="Preview" className="img-thumbnail mt-2" style={{ width: "100px", height: "100px" }} />}
              </div>

              {/* Submit Button */}
              <div className="col-12 text-end">
                <button type="submit" className="btn submitbtnn">Update Category</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategory;
